import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings, CreditCard } from "lucide-react";
import { CancelSubscriptionDialog } from "./CancelSubscriptionDialog";
import type { SubscriptionDetailed } from "@/api/generated/client/models/SubscriptionDetailed";

interface SubscriptionManagementCardProps {
  subscription: SubscriptionDetailed;
  onManageBilling: () => void;
  onCancelSubscription: () => void;
  isAdmin: boolean;
}

export function SubscriptionManagementCard({
  subscription,
  onManageBilling,
  onCancelSubscription,
  isAdmin,
}: SubscriptionManagementCardProps) {
  return (
    <div className="max-w-7xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Subscription Management
          </CardTitle>
          <CardDescription>
            {isAdmin 
              ? "Manage your billing and subscription settings" 
              : "View subscription details (Admin-only actions)"}
          </CardDescription>
        </CardHeader>
        {isAdmin && (
          <CardContent>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="outline"
                className="flex-1"
                onClick={onManageBilling}
              >
                <CreditCard className="h-4 w-4 mr-2" />
                Manage Billing
              </Button>
              <CancelSubscriptionDialog
                onConfirm={onCancelSubscription}
                renewsAt={subscription.renewsAt}
                disabled={!!subscription.canceledAt}
              />
            </div>
          </CardContent>
        )}
      </Card>
    </div>
  );
}
